import { MenuItem } from "@mui/material";
import { useTaxPurposes } from "@app/hooks/useTaxPurposes";
import { CarSelectField, CarSelectFieldProps } from "./Inputs";

export const CarTaxPurposeField = (props: CarSelectFieldProps) => {
  const { items } = useTaxPurposes();
  return (
    <CarSelectField {...props}>
      {items.map((i) => (
        <MenuItem key={i.id} value={i.id}>
          {i.name}
        </MenuItem>
      ))}
    </CarSelectField>
  );
};
